import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Button } from 'swag-client-common/components/ui/button';
import { Price } from 'swag-client-common/utils/price';
import Drawer from '../../ui/drawer';
import CSSclasses from './samples-drawer.scss';
import errorAnimationClasses from './error.anim.scss';
import SampleDrawerSizePicker from './sample-drawer-size-picker';
import { sizeErrorMessage, mockupErrorMessage } from './sample-drawer.constants';
export function SamplesDrawerComponent({
  open,
  onClose,
  blankSamplePrice,
  printedSamplePrice,
  isDesignUploaded,
  onBuyPrinted,
  onBuyBlank,
  isPrintedSampleAvailable,
  embellishmentError,
  onClickBuyPrinted,
  onChangeSize,
  size,
  isApparel,
  isBlankSampleAvailable,
  outOfStockSizes
}) {
  const [isPrintedSampleError, setPrintedSampleError] = useState(false);
  const [isPrintedSizeError, setIsPrintedSizeError] = useState(false);
  const [isBlankSizeError, setIsBlankSizeError] = useState(false);
  const [blankSize, setBlankSize] = useState(null);
  const [printedSize, setPrintedSize] = useState(null);
  const onBlankSelectSize = size => () => {
    setBlankSize(size);
  };
  const onPrintedSelectSize = size => () => {
    setPrintedSize(size);
  };
  const resetErrors = () => {
    setPrintedSampleError(false);
    setIsPrintedSizeError(false);
    setIsBlankSizeError(false);
  };
  const onBuyBlankClick = () => {
    if (isApparel && !Number.isFinite(blankSize)) {
      return setIsPrintedSizeError(true);
    }
    if (Number.isFinite(blankSize)) {
      onChangeSize(blankSize);
    }
    resetErrors();
    onBuyBlank();
  };
  const onBuyPrintedClick = () => {
    onClickBuyPrinted();
    if (!isDesignUploaded || embellishmentError) {
      return setPrintedSampleError(true);
    }
    if (isApparel && !Number.isFinite(printedSize)) {
      return setIsBlankSizeError(true);
    }
    if (Number.isFinite(printedSize)) {
      onChangeSize(printedSize);
    }
    resetErrors();
    onBuyPrinted();
  };
  const isMockupError = () => {
    return isPrintedSampleError && (!isDesignUploaded || embellishmentError);
  };
  useEffect(() => {
    if (!open) {
      resetErrors();
    }
  });
  return /*#__PURE__*/React.createElement(Drawer, {
    prerenderForCrawlers: true,
    dataDrawer: "Sample",
    open: open,
    onClose: onClose,
    headerTitle: "Buy sample",
    headerClassName: CSSclasses.header
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.container
  }, isBlankSampleAvailable && /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.sampleItem,
    "data-block": "BlankSample"
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.sampleItemHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.title
  }, "Blank"), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.titlePrice,
    "data-price": "Blank"
  }, Price.formatPrice(blankSamplePrice))), /*#__PURE__*/React.createElement("p", null, "This \"blank\" sample will not have your printed design on it. Instead, it will either be a sample of the product with a pre-selected design or no design included so that you are able to see the product quality."), /*#__PURE__*/React.createElement(CSSTransition, {
    in: isPrintedSizeError,
    timeout: 500,
    classNames: errorAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.errorMessageWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: CSSclasses.errorMessage
  }, sizeErrorMessage))), isApparel && /*#__PURE__*/React.createElement(SampleDrawerSizePicker, {
    size: size,
    selectedIndex: blankSize,
    outOfStockSizes: outOfStockSizes,
    onSelectSize: onBlankSelectSize
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onBuyBlankClick,
    dataButton: "Blank",
    type: "primary",
    className: CSSclasses.button
  }, "Buy Blank")), isPrintedSampleAvailable && /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.sampleItem,
    "data-block": "PrintedSample"
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.sampleItemHeader
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.title
  }, "Printed"), /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.titlePrice,
    "data-price": "Printed"
  }, Price.formatPrice(printedSamplePrice))), /*#__PURE__*/React.createElement("p", null, "We will send you a sample of what the exact product will look like including your printed design. If you like the printed sample and want to place a full order, we will deduct the ", Price.formatPrice(printedSamplePrice), " from your regular order price."), /*#__PURE__*/React.createElement(CSSTransition, {
    in: isMockupError() || isBlankSizeError,
    timeout: 500,
    classNames: errorAnimationClasses,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: CSSclasses.errorMessageWrapper
  }, /*#__PURE__*/React.createElement("span", {
    className: CSSclasses.errorMessage
  }, isMockupError() ? mockupErrorMessage : sizeErrorMessage))), isApparel && /*#__PURE__*/React.createElement(SampleDrawerSizePicker, {
    size: size,
    selectedIndex: printedSize,
    outOfStockSizes: outOfStockSizes,
    onSelectSize: onPrintedSelectSize
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onBuyPrintedClick,
    dataButton: "Printed",
    type: "primary",
    className: CSSclasses.button
  }, "Buy Printed"))));
}